const isProjectCompleted = (project) => {
  const status = project?.status;

  if (!status) {
    return false;
  }

  return status === 'Completed';
};

export default isProjectCompleted;
